<template>
  <div>
    <transition name="modal" v-if="sendMgmModal">
      <div class="modal" style="display:block;background-color:rgba(0,0,0,.5)">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalCenterTitle">
                {{ $t("Invita amici via") }} {{ $t(invitationType) }}
              </h5>
              <button
                type="button"
                class="close"
                @click="
                  sendMgmModal = false;
                  resetModal();
                "
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form
              data-vv-scope="sendMgmForm"
              @submit.prevent="validateForm('sendMgmForm', sendInvitation)"
              v-cloak
            >
              <div
                class="modal-body"
                v-if="modalStep === 0"
                style="padding-top: 3rem;padding-bottom: 3rem;"
              >
                <div class="form-group">
                  <input
                    type="email"
                    v-model="invitationCredential"
                    name="credential"
                    id="credential"
                    class="form-control"
                    placeholder=" "
                    :data-vv-as="$t('Email address')"
                    v-if="invitationType === 'email'"
                    v-validate="'required|email'"
                  />
                  <input
                    type="text"
                    v-model="invitationCredential"
                    name="credential"
                    id="credential"
                    class="form-control"
                    placeholder=" "
                    :data-vv-as="$t('Mobile number')"
                    v-validate="'required|phone'"
                    v-if="invitationType === 'mobile'"
                  />
                  <label for="credential" v-if="invitationType === 'email'">{{
                    $t("Email")
                  }}</label>
                  <label for="credential" v-if="invitationType === 'mobile'">{{
                    $t("Cellulare")
                  }}</label>
                  <span
                    v-show="errors.has('sendMgmForm.credential')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>{{
                      errors.first("sendMgmForm.credential")
                    }}</strong>
                  </span>
                </div>
                <div class="form-group" style="margin-top: 45px;">
                  <template v-if="invitationType === 'email'">
                    <textarea
                      v-model="invitationEmailMessage"
                      placeholder="add multiple lines"
                      name="message"
                      id="message"
                      class="form-control"
                      rows="3"
                    ></textarea>
                    <label for="message">{{ $t("Testo dell’email") }}</label>
                  </template>
                  <template v-if="invitationType === 'mobile'">
                    <textarea
                      v-model="invitationMobileMessage"
                      placeholder="add multiple lines"
                      name="message"
                      id="message"
                      class="form-control"
                      rows="3"
                      maxlength="120"
                    ></textarea>
                    <label for="message">{{ $t("Testo del messaggio") }}</label>
                  </template>
                </div>
              </div>
              <div
                class="modal-body text-center"
                style="padding-top: 3rem;padding-bottom: 3rem;"
                v-if="modalStep === 1"
              >
                <h3>{{ $t("Il tuo invito è stato inviato") }}</h3>
                <a
                  @click="
                    modalStep = 0;
                    invitationCredential = '';
                  "
                  href="#"
                  >{{ $t("Invita un altro amico via") }}
                  {{ $t(invitationType) }}</a
                >
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="
                    sendMgmModal = false;
                    resetModal();
                  "
                >
                  {{ $t("Chiudi") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  v-if="modalStep === 0"
                >
                  {{ $t("Invita") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </transition>
    <main
      class="code d-flex align-items-center"
      v-if="finishedLoading && currentUserMgmLink"
    >
      <div class="w-100">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h3>{{ $t("Invita i tuoi amici") }}</h3>
              <p>
                {{ $t("Puoi guadagnare") }}
                <strong>10 {{ $t("coins") }}</strong>
                {{ $t("invitando gli amici sulla piattaforma") }} <br />{{
                  $t("Attualmente hai invitato")
                }}
                <strong>{{ this.referredCount }} {{ $t("persone") }}</strong>
              </p>
              <div class="form-group">
                <input
                  name="affiliate-url"
                  type="text"
                  placeholder="affiliate"
                  id="affiliate-url"
                  :value="currentUserMgmLink"
                  readonly="readonly"
                  class="form-control text-left withval"
                />
              </div>
              <div class="align-items-center invite-friends">
                <button
                  data-toggle="popover"
                  data-placement="top"
                  data-trigger="focus"
                  tabindex="0"
                  role="button"
                  class="js-clipboard-copy btn btn-sm btn-primary text-uppercase btn-copy c-clipboard-copy mr-2"
                  data-original-title
                  title
                  @click="copyToClipboard"
                >
                  <i class="fas fa-clone f-icon"></i>
                  {{ $t("Copia nella clipboard") }}
                </button>
                <button
                  class="btn btn-sm btn-primary text-uppercase btn-copy mr-2"
                  @click="
                    sendMgmModal = true;
                    invitationType = 'email';
                  "
                >
                  <i class="fas fa-at f-icon" style="font-size: 18px;"></i>
                  {{ $t("Invita via email") }}
                </button>
                <button
                  class="btn btn-sm btn-primary text-uppercase btn-copy"
                  @click="
                    sendMgmModal = true;
                    invitationType = 'mobile';
                  "
                >
                  <i
                    class="fas fa-comment-alt f-icon"
                    style="font-size: 18px;"
                  ></i>
                  {{ $t("Invita via numero di cellulare") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: "Invite",
  data: function() {
    return {
      finishedLoading: false,
      sendMgmModal: false,
      modalStep: 0,
      invitationType: "",
      invitationEmailMessage: this.$store.state.campaign.defaultinviteemail,
      invitationMobileMessage: this.$store.state.campaign.defaultinvitesms,
      invitationCredential: "",
      referredCount: 0
    };
  },
  created() {
    this.$http
      .get(
        "/api/v1/campaigns/" +
          this.$store.state.campaign.id +
          "/users/referred/count"
      )
      .then(response => {
        this.referredCount = response.data.data.count;
        this.finishedLoading = true;
      });
  },
  computed: {
    affiliateId() {
      return this.$store.state.user.affiliate_id;
    },
    currentUserMgmLink() {
      if (this.affiliateId) {
        return (
          window.location.protocol +
          "//" +
          window.location.hostname +
          "/?ref=" +
          this.affiliateId
        );
      }

      return false;
    }
  },
  methods: {
    copyToClipboard() {
      var copyText = document.getElementById("affiliate-url");
      copyText.select();
      document.execCommand("copy");
    },
    sendInvitation() {
      this.$store.commit("showSpinner");
      let message =
        this.invitationType === "email"
          ? this.invitationEmailMessage
          : this.invitationMobileMessage;
      this.$http
        .post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/sendMgm",
          {
            address: this.invitationCredential,
            message: message,
            type: this.invitationType
          }
        )
        .then(response => {
          this.modalStep = 1;
        })
        .catch(err => {
          if (_.get(err, "response.status") == 409) {
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: this.$i18n.t("L'utente è già registrato")
            });
          } else {
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: "Something went wrong",
              text: "Please retry"
            });
          }
        })
        .finally(() => {
          this.$store.commit("hideSpinner");
        });
    },
    resetModal() {
      this.invitationType = "";
      this.invitationCredential = "";
      this.invitationEmailMessage = this.$store.state.campaign.defaultinviteemail;
      this.invitationMobileMessage = this.$store.state.campaign.defaultinvitesms;
      this.modalStep = 0;
    }
  }
};
</script>
<style scoped>
main h5 {
  font-size: 30px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.53;
  letter-spacing: normal;
  text-align: left;
}
.invite-friends {
  display: flex;
}

.c-clipboard-copy i {
  font-size: 18px;
}

@media (max-width: 767px) {
  .invite-friends {
    display: block;
  }
  .invite-friends button {
    display: block;
    width: 100%;
    min-width: auto;
    padding: 8px 15px;
    margin-bottom: 0.75rem;
  }
}
</style>
